export const STATUS_LABEL = {
  en_attente: "En attente",
  verifie: "Vérifié",
  envoye: "Envoyé",
  termine: "Terminé",
  annule: "Annulé",
};

export const STATUS_CLASS = {
  en_attente: "sl-badge sl-badge-pending",
  verifie: "sl-badge sl-badge-verified",
  envoye: "sl-badge sl-badge-sent",
  termine: "sl-badge sl-badge-completed",
  annule: "sl-badge sl-badge-cancelled",
};

export const CORRIDORS = {
  tg_ga: {
    id: "tg_ga",
    label: "Togo → Gabon",
    short: "TG → GA",
    source_currency: "XOF",
    target_currency: "XAF",
    flagFrom: "🇹🇬",
    flagTo: "🇬🇦",
    description: "Mobile Money Togo → Mobile Money Gabon",
    senderDialCode: "+228",
    beneficiaryDialCode: "+241",
  },
  ga_fr: {
    id: "ga_fr",
    label: "Gabon → France",
    short: "GA → FR",
    source_currency: "XAF",
    target_currency: "EUR",
    flagFrom: "🇬🇦",
    flagTo: "🇫🇷",
    description: "Airtel Money Gabon → PayPal / Wero / Virement instantané",
    senderDialCode: "+241",
    beneficiaryDialCode: "+33",
  },
  ga_rw: {
    id: "ga_rw",
    label: "Gabon → Rwanda",
    short: "GA → RW",
    source_currency: "XAF",
    target_currency: "RWF",
    flagFrom: "🇬🇦",
    flagTo: "🇷🇼",
    description: "Airtel Money Gabon → MTN / Tigo / Airtel Money Rwanda",
    senderDialCode: "+241",
    beneficiaryDialCode: "+250",
  },
  fr_ga: {
    id: "fr_ga",
    label: "France → Gabon",
    short: "FR → GA",
    source_currency: "EUR",
    target_currency: "XAF",
    flagFrom: "🇫🇷",
    flagTo: "🇬🇦",
    description: "Échangez vos euros en FCFA via PayPal — réception sur Airtel Money Gabon",
    senderDialCode: "+33",
    beneficiaryDialCode: "+241",
    // Special flow: sender pays via PayPal Friends & Family (no phone required)
    senderUsesEmail: true,
  },
};

export const DIAL_CODES = {
  TG: "+228",
  GA: "+241",
  FR: "+33",
  RW: "+250",
};

export const SUPPORT_NUMBERS = [
  { country: "France", flag: "🇫🇷", phone: "+33 7 53 72 81 95", waLink: "https://wa.me/33753728195" },
  { country: "Rwanda", flag: "🇷🇼", phone: "+250 787 195 886", waLink: "https://wa.me/250787195886" },
  { country: "Togo", flag: "🇹🇬", phone: "+228 99 82 57 04", waLink: "https://wa.me/22899825704" },
];

// Operator-specific phone validation patterns (digits only, without dial code).
// Each pattern is described with a regex + a human-readable hint.
export const PHONE_VALIDATION = {
  moov_togo: {
    pattern: /^9[6-9]\d{6}$/,
    length: 8,
    hint: "8 chiffres débutant par 96, 97, 98 ou 99",
    label: "Moov Togo",
  },
  tmoney_togo: {
    pattern: /^9[0-3]\d{6}$/,
    length: 8,
    hint: "8 chiffres débutant par 90, 91, 92 ou 93",
    label: "TMoney / Yas",
  },
  airtel_gabon: {
    pattern: /^(0?[4-7]\d{6,7}|7[4-7]\d{6})$/,
    length: 8,
    hint: "8 chiffres débutant par 7, 04, 05, 06 ou 07",
    label: "Airtel Money Gabon",
  },
  airtel_gabon_gafr: {
    pattern: /^(0?[4-7]\d{6,7}|7[4-7]\d{6})$/,
    length: 8,
    hint: "8 chiffres débutant par 7, 04, 05, 06 ou 07",
    label: "Airtel Money Gabon",
  },
  moov_gabon: {
    pattern: /^[0-9]\d{7}$/,
    length: 8,
    hint: "8 chiffres",
    label: "Moov Money Gabon",
  },
  france_mobile: {
    pattern: /^[67]\d{8}$/,
    length: 9,
    hint: "9 chiffres débutant par 6 ou 7",
    label: "Mobile France",
  },
  france_any: {
    pattern: /^[1-9]\d{8}$/,
    length: 9,
    hint: "9 chiffres (mobile ou fixe)",
    label: "France",
  },
  mtn_rwanda: {
    pattern: /^7[89]\d{7}$/,
    length: 9,
    hint: "9 chiffres débutant par 78 ou 79",
    label: "MTN Mobile Money Rwanda",
  },
  tigo_rwanda: {
    pattern: /^7[23]\d{7}$/,
    length: 9,
    hint: "9 chiffres débutant par 72 ou 73",
    label: "Tigo Cash Rwanda",
  },
  airtel_rwanda: {
    pattern: /^7[3578]\d{7}$/,
    length: 9,
    hint: "9 chiffres débutant par 73, 75, 78",
    label: "Airtel Money Rwanda",
  },
};

/** Strip a dial code prefix and any non-digit, return local digits only. */
export function stripDialCode(fullValue, dialCode) {
  if (!fullValue) return "";
  const rest = fullValue.startsWith(dialCode) ? fullValue.slice(dialCode.length) : fullValue;
  return rest.replace(/\D/g, "");
}

/**
 * Detect the operator from local digits.
 * Returns one of the method keys or null if undetectable.
 */
export function detectOperator(localDigits, country) {
  if (!localDigits) return null;
  if (country === "TG") {
    if (localDigits.length < 2) return null;
    const p = localDigits.slice(0, 2);
    if (["96", "97", "98", "99"].includes(p)) return "moov_togo";
    if (["90", "91", "92", "93"].includes(p)) return "tmoney_togo";
    return null;
  }
  if (country === "GA") {
    if (localDigits.length < 2) return null;
    const first2 = localDigits.slice(0, 2);
    const first1 = localDigits.slice(0, 1);
    // Airtel Gabon: starts with 7 (often 74-77) or 04-07
    if (first1 === "7" || ["04", "05", "06", "07"].includes(first2) || ["74", "75", "76", "77"].includes(first2)) {
      return "airtel_gabon";
    }
    return "moov_gabon";
  }
  if (country === "RW") {
    if (localDigits.length < 2) return null;
    const p = localDigits.slice(0, 2);
    if (["78", "79"].includes(p)) return "mtn_rwanda";
    if (["72"].includes(p)) return "tigo_rwanda";
    if (["73", "75"].includes(p)) return "airtel_rwanda";
    return null;
  }
  return null;
}

/**
 * Detect operator from a phone value (with dial code) for a given corridor country.
 * Returns operator method id or null.
 */
export function detectOperatorFromPhone(phoneValue, dialCode, country) {
  return detectOperator(stripDialCode(phoneValue, dialCode), country);
}

/** Validate a phone given the operator method. Returns { valid: boolean, message: string }. */
export function validatePhone(method, fullValue, dialCode) {
  const digits = stripDialCode(fullValue, dialCode);
  if (!digits) return { valid: false, message: "Numéro requis" };
  const v = PHONE_VALIDATION[method];
  if (!v) return { valid: digits.length >= 6, message: digits.length >= 6 ? "" : "Numéro trop court" };
  if (!v.pattern.test(digits)) {
    return { valid: false, message: `Format ${v.label} invalide — ${v.hint}` };
  }
  return { valid: true, message: "" };
}

export const DEPOSIT_METHODS = {
  moov_togo: {
    corridor: "tg_ga",
    label: "Moov Money Togo",
    number: "99825704",
    name: "Ameyayra Koffi Mawuyram",
  },
  tmoney_togo: {
    corridor: "tg_ga",
    label: "T-Money / Mixx by Yas",
    number: "92365789",
    name: "Ameyayra Koffi Mawuyram",
  },
  airtel_gabon_gafr: {
    corridor: ["ga_fr", "ga_rw"],
    label: "Airtel Money Gabon",
    number: "+241 77861180",
    name: "Owanga Larry Franck",
  },
  paypal_send: {
    corridor: "fr_ga",
    label: "PayPal — Entre proches (Friends & Family)",
    paypal_email: "marketlineplus56@gmail.com",
    name: "Swiftlink Africa",
    instructions: "Important : sélectionnez bien le mode « Entre proches / Friends & Family » avant de valider, sinon PayPal appliquera ses frais commerciaux.",
  },
  wero_send: {
    corridor: "fr_ga",
    label: "Wero",
    wero_number: "+33 7 49 57 44 48",
    name: "MOULEMA Cerny SOKI",
    instructions: "Envoyez le montant via Wero au numéro ci-dessus, puis téléversez la capture du paiement.",
  },
};

export const RECEPTION_METHODS = {
  airtel_gabon: { corridor: "tg_ga", label: "Airtel Money Gabon", fields: ["phone"] },
  moov_gabon: { corridor: "tg_ga", label: "Moov Money Gabon", fields: ["phone"] },
  paypal: { corridor: "ga_fr", label: "PayPal", fields: ["email"], hint: "Email PayPal du bénéficiaire" },
  wero: { corridor: "ga_fr", label: "Wero", fields: ["account"], hint: "Numéro de téléphone ou email Wero" },
  virement_instantane: { corridor: "ga_fr", label: "Virement instantané (SEPA)", fields: ["account"], hint: "IBAN du bénéficiaire" },
  mtn_rwanda: { corridor: "ga_rw", label: "MTN Mobile Money Rwanda", fields: ["phone"] },
  tigo_rwanda: { corridor: "ga_rw", label: "Tigo Cash Rwanda", fields: ["phone"] },
  airtel_rwanda: { corridor: "ga_rw", label: "Airtel Money Rwanda", fields: ["phone"] },
  // FR → GA : reception via Airtel Money Gabon
  airtel_gabon_frga: { corridor: "fr_ga", label: "Airtel Money Gabon", fields: ["phone"] },
  moov_gabon_frga: { corridor: "fr_ga", label: "Moov Money Gabon", fields: ["phone"] },
};

export function depositMethodsFor(corridor) {
  return Object.entries(DEPOSIT_METHODS).filter(([, v]) =>
    Array.isArray(v.corridor) ? v.corridor.includes(corridor) : v.corridor === corridor
  );
}
export function receptionMethodsFor(corridor) {
  return Object.entries(RECEPTION_METHODS).filter(([, v]) =>
    Array.isArray(v.corridor) ? v.corridor.includes(corridor) : v.corridor === corridor
  );
}

function _fmt(n, suffix, frac = 0) {
  return new Intl.NumberFormat("fr-FR", {
    minimumFractionDigits: frac,
    maximumFractionDigits: frac,
  }).format(Number(n) || 0) + " " + suffix;
}

export function formatXOF(n) { return _fmt(n, "XOF"); }
export function formatXAF(n) { return _fmt(n, "XAF"); }
export function formatEUR(n) { return _fmt(n, "EUR", 2); }
export function formatRWF(n) { return _fmt(n, "RWF"); }

export function formatAmount(n, currency) {
  if (currency === "EUR") return formatEUR(n);
  if (currency === "XAF") return formatXAF(n);
  if (currency === "RWF") return formatRWF(n);
  return formatXOF(n);
}

export function formatDate(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleString("fr-FR", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
}
